import { connect } from 'react-redux';
import { pick } from '../../../lib/utils';
import { fetchBadgeAds } from '../../actions/badge-ads';
import BadgeAds from './BadgeAds';

function mapStateToProps({ badgeAds }, { badgeIds }) {
  return {
    badgeAdsById: pick(badgeAds.byId, badgeIds),
    error: badgeAds.error,
    isFetching: badgeAds.isFetching,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchBadgeAds: badgeIds => dispatch(fetchBadgeAds(badgeIds)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BadgeAds);
